import { memo } from 'react'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import remarkMath from 'remark-math'
import remarkSupersub from 'remark-supersub'
import remarkDirective from 'remark-directive'
import rehypeKatex from 'rehype-katex'
import rehypeHighlight from 'rehype-highlight'
import type { Pluggable } from 'unified'
import { markdownComponents } from './MarkdownComponents'

const remarkPlugins: Pluggable[] = [
  remarkSupersub,
  remarkGfm,
  remarkDirective,
  [remarkMath, { singleDollarTextMath: false }]
]
const rehypePlugins = [
  rehypeKatex,
  [rehypeHighlight as Pluggable, { detect: true, ignoreMissing: true }]
] as Pluggable[]

export interface MarkdownMessageProps {
  text: string
  className?: string
}

export const MarkdownMessage = memo(({ text, className = 'mp-agent-message-markdown' }: MarkdownMessageProps) => {
  return (
    <ReactMarkdown
      className={className}
      remarkPlugins={remarkPlugins}
      rehypePlugins={rehypePlugins}
      components={markdownComponents}
    >
      {text}
    </ReactMarkdown>
  )
})

MarkdownMessage.displayName = 'MarkdownMessage'
